<div class="{{className}}">
    <ng-content></ng-content>
</div>
